// Data embedded by the build-time prerenderer (window.__PRERENDER_DATA__ on the client,
// globalThis.__PRERENDER_DATA__ in Node). Lets pages render real content on first paint.
export const prerenderData = () =>
  (typeof globalThis !== 'undefined' && globalThis.__PRERENDER_DATA__) || null;

export const prerenderedPost = (slug) => {
  const d = prerenderData();
  return d?.post && d.post.slug === slug ? d.post : null;
};

export const prerenderedPosts = () => prerenderData()?.posts || null;
